<script lang="ts">
    import {_, time} from 'svelte-i18n'
    import type {Conversation} from './types';
    import {SecondaryText} from '@smui/list';
    import Card, {Actions, Content} from '@smui/card';
    import Button from '@smui/button';
    import {Label} from '@smui/common';
    import ConversationName from './ConversationName.svelte';
    import {isArchivable, isDetailDisplayable, isStartable} from './service/util';
    import {conversations, mySession, paths, walker} from './services';
    import {get} from 'svelte/store';
    import ConversationWaitingDuration from './ConversationWaitingDuration.svelte';
    import ConversationActiveDuration from './ConversationActiveDuration.svelte';
    import ConversationLocale from './ConversationLocale.svelte';

    export let waitingConversations: Conversation[];

    let sortedConversations: Conversation[];

    $: sortedConversations = waitingConversations.map(value => value).sort((a, b) => b.createDate - a.createDate); // map is here for creating new array before in-place sorting

    async function startConversation(conversation: Conversation) {
        await conversations.startConversation(conversation, get(mySession));
        await walker.goTo(get(paths).conversation(conversation));
    }

    async function showConversation(conversation: Conversation) {
        await walker.goTo(get(paths).conversation(conversation));
    }

    async function archiveConversation(conversation: Conversation) {
        await conversations.archiveConversation(conversation);
    }
</script>

{#each sortedConversations as conversation (conversation.id)}
    <div class="card-container short">
        <Card style="width: 320px; margin: 10px 0;">
            <Content>
                <div style="float: right">
                    <ConversationLocale conversation={conversation} />
                </div>
                <ConversationName conversation={conversation} />
                <SecondaryText>
                    <div>
                        {$_('chat.Waiting')} <ConversationWaitingDuration conversation={conversation} /> ({$_('commons.from')} {$time(conversation.createDate, {format: 'short'})})
                    </div>
                    {#if conversation.startDate}
                        <div>
                            {$_('chat.Ongoing')} <ConversationActiveDuration conversation={conversation} /> ({$_('commons.from')} {$time(conversation.startDate, {format: 'short'})})
                        </div>
                    {/if}
                    {#if conversation.endDate}
                        <div>{$_('chat.Ended')} {$time(conversation.endDate, {format: 'short'})}</div>
                    {/if}
                </SecondaryText>
            </Content>
            <Actions>
                {#if isStartable(conversation, $mySession)}
                    <Button on:click={() => startConversation(conversation)} variant="unelevated"><Label>{$_('chat.Start')}</Label></Button>
                {/if}
                {#if isDetailDisplayable(conversation, $mySession)}
                    <Button on:click={() => showConversation(conversation)} variant="unelevated"><Label>{$_('chat.Show')}</Label></Button>
                {/if}
                {#if isArchivable(conversation, $mySession)}
                    <Button on:click={() => archiveConversation(conversation)} variant="unelevated"><Label>{$_('chat.Delete')}</Label></Button>
                {/if}
            </Actions>
        </Card>
    </div>
{/each}